import { type MedicalAppointmentRequestFiltersUrl } from "@/routes/gestor-citas/-src/interfaces/appointment";

type QueryParamPrimitive = string | number | boolean;
type QueryParamValue = QueryParamPrimitive | null | undefined;
type QueryParamObject = Record<string, QueryParamValue>;

export const getParamUrl = (nameParam: string): string => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let paramUrlValue = urlParams.get(nameParam);
  return paramUrlValue ?? '';
}

export const existQueryParamUrl = (): boolean => {
  return window.location.search.length > 0;
}

export const buildQueryParams = <T extends QueryParamObject>(
  filters: T
): string => {
  const queryParams = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      queryParams.append(key, String(value));
    }
  });

  const queryString = queryParams.toString();
  return queryString ? `?${queryString}` : "";
};

export const buildMedicalAppointmentQueryParams = (
  filters: MedicalAppointmentRequestFiltersUrl
): string => {
  return buildQueryParams(filters);
};

export const queryUrlToObject = function queryToObject<T extends object>(
  query: string
): T {
  const localQuery = query.startsWith("?") ? query.slice(1) : query;
  const map = new Map<string, string>();
  localQuery.split("&").forEach((curr) => {
    const [key, value] = curr.split("=");
    if (key)
      map.set(key, decodeURIComponent(value));
  });
  return Object.fromEntries(map) as T;
};

export const objectToQueryUrl = <T extends Record<string, unknown>>(
  query: T,
  initialValue = "?"
) => {
  return Object.entries(query).reduce<string>(
    (acc, curr, index, arr) => {
      if (curr[1] !== null && curr[1] !== undefined && curr[1] !== "") {
        return acc.concat(
          `${curr[0]}=${encodeURIComponent((curr[1] as string) ?? "")}${index === arr.length - 1 ? "" : "&"}`
        )
      } else return acc;
    },
    initialValue
  ).replace(/&$/, "");
};